import React, { Suspense, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAuthToken from "./services/AuthToken";
import Sidebar from "./component/common/Sidebar";
import Loader from "./component/loader/Loader";
import Router from "./routes/router";

function App() {
  const isAuthenticated = useAuthToken();
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const shouldRenderNavbar = [
    "/login",
    "/contact-us",
    "/privacy-policy",
    "/new-registration-form",
  ].includes(pathname);

  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [pathname]);

  useEffect(() => {
    const publicRoutes = [
      "/login",
      "/contact-us",
      "/privacy-policy",
      "/new-registration-form",
    ];
    if (
      isAuthenticated !== null &&
      !isAuthenticated &&
      !publicRoutes.includes(pathname)
    ) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate, pathname]);

  return (
    <div className="flex h-screen bg-gray-200">
      {!shouldRenderNavbar && <Sidebar />}
      <div className="w-full h-screen overflow-y-scroll scrollbar-hide">
        {showLoader ? (
          <Loader />
        ) : (
          <Suspense fallback={<Loader />}>
            <Router />
          </Suspense>
        )}
      </div>
    </div>
  );
}

export default App;
